import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ProgressBar from 'react-bootstrap/ProgressBar'

const ImportProgressAlert = ({ municipalityAnalytic, expectingWork = false }) => {
  // null whenever the municipality has not enabled this analytic — the API sends
  // municipality_analytic: nil in that case.
  const { status, import_progress, import_processed_rows, import_total_rows, import_error } =
    municipalityAnalytic || {}
  const [visible, setVisible] = useState(false)
  const [showComplete, setShowComplete] = useState(false)
  const timerRef = useRef(null)

  const isWorking = status === 'processing' || status === 'queued'
  const isImport = (import_total_rows || 0) !== 0

  useEffect(() => {
    if (isWorking || expectingWork) {
      setVisible(true)
      setShowComplete(false)
    } else if (visible && !expectingWork) {
      setShowComplete(true)
      timerRef.current = setTimeout(() => {
        setVisible(false)
        setShowComplete(false)
      }, 3000)
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [status, expectingWork])

  if (!visible) return null

  const progress = showComplete ? 100 : (import_progress || 0)
  const processedRows = import_processed_rows || 0
  const totalRows = import_total_rows || 0

  const label = showComplete
    ? (isImport ? 'Import Complete' : 'Recalculation Complete')
    : (isImport ? 'Importing Analytic Results' : 'Recalculating transaction risk scores')

  return (
    <div className="mb-3">
      <div className="mb-2">
        <small className="fw-bold">{label}</small>
      </div>
      <ProgressBar
        now={isImport ? progress : 100}
        className="mb-2"
        variant={showComplete ? 'success' : 'primary'}
        animated={!showComplete}
        label={isImport ? `${progress}%` : undefined}
      />
      {isImport && totalRows > 0 && !showComplete && (
        <small className="text-muted">
          Processing {processedRows.toLocaleString()} of {totalRows.toLocaleString()} rows
        </small>
      )}
      {import_error && (
        <div className="mt-2 text-danger">
          <small>Error: {import_error}</small>
        </div>
      )}
    </div>
  )
}

ImportProgressAlert.propTypes = {
  municipalityAnalytic: PropTypes.shape({
    status: PropTypes.string,
    import_progress: PropTypes.number,
    import_processed_rows: PropTypes.number,
    import_total_rows: PropTypes.number,
    import_error: PropTypes.string
  }).isRequired,
  expectingWork: PropTypes.bool
}

export default ImportProgressAlert
